
const upRecordMoudle={
  namespaced: true,
  state:{
    searchSN:''
  },
  mutations:{

  },
  getters:{

  },
  actions:{

  }
};

export default upRecordMoudle;



// WEBPACK FOOTER //
// ./src/store/moudles/upRecord.js